// Module
var code = `<div class="form-group schema-form-submit {{form.htmlClass}}">
  <input type="submit"
         class="btn {{ form.style || 'btn-primary' }} {{form.fieldHtmlClass}}"
         value="{{form.title}}"
         ng-disabled="form.readonly"
         ng-if="form.type === 'submit'">
  <button class="btn {{ form.style || 'btn-default' }}"
          type="button"
          ng-click="buttonClick(\$event,form)"
          ng-disabled="form.readonly"
          ng-if="form.type !== 'submit'">
      <span ng-if="form.icon" class="{{form.icon}}"></span>
      {{form.title}}
  </button>
</div>
`;
// Exports
module.exports = code;